export default __webpack_public_path__ + "static/media/mainkitten.7ea4a60c.jpg";